import DialogComponent from '../widgets/dialog/DialogComponent';
import prefService from '../../services/pref-service';
import { Switch } from '../widgets/beauty/input';

export default class CustomizeDialog extends DialogComponent {

  state = {
    map: false,
    graph: false,
    alarm: false,
    group: false
  }

  render() {
    const state = this.state;
    return (
      <div className="customize-dialog-component">
        <div>
          <div className="row row-item">
            <div className="col-6">نقشه</div>
            <div className="col-6">
              <Switch checked={state.map} onChange={this.handleSwitchClicked.bind(this, 'map')} />
            </div>
          </div>
          <div className="row row-item">
            <div className="col-6">گراف روزانه</div>
            <div className="col-6">
              <Switch checked={state.graph} onChange={this.handleSwitchClicked.bind(this, 'graph')} />
            </div>
          </div>
          <div className="row row-item">
            <div className="col-6">سنسورهای در حال هشدار</div>
            <div className="col-6">
              <Switch checked={state.alarm} onChange={this.handleSwitchClicked.bind(this, 'alarm')} />
            </div>
          </div>
          <div className="row row-item">
            <div className="col-6">گروه بندی (به زودی)</div>
            <div className="col-6">
              <Switch checked={state.group} onChange={this.handleSwitchClicked.bind(this, 'group')} />
            </div>
          </div>
        </div>
        <button className="btn btn-primary btn-submit" onClick={this.handleSaveClicked}>ذخیره اطلاعات</button>
      </div>
    );
  }

  componentDidMount = async () => {
    try {
      const prefs = await prefService.getHomePrefs();
      this.setState(prefs);
    }
    catch (e) {
      console.error(e);
    }
  }

  handleSwitchClicked = (key: string) => {
    const value = this.state[key];
    this.setState({ [key]: !value });
  }

  handleSaveClicked = async () => {
    const data = this.state;
    try {
      await prefService.updateHomePrefs(data);
      this.close(true);
    }
    catch(e) {
      console.error(e);
    }
  }

}
